import { render, staticRenderFns } from "./SalesInvoicing.vue?vue&type=template&id=2db3aeb8&scoped=true&"
import script from "./SalesInvoicing.vue?vue&type=script&lang=js&"
export * from "./SalesInvoicing.vue?vue&type=script&lang=js&"
import style0 from "./SalesInvoicing.vue?vue&type=style&index=0&id=2db3aeb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db3aeb8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db3aeb8')) {
      api.createRecord('2db3aeb8', component.options)
    } else {
      api.reload('2db3aeb8', component.options)
    }
    module.hot.accept("./SalesInvoicing.vue?vue&type=template&id=2db3aeb8&scoped=true&", function () {
      api.rerender('2db3aeb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SalesInvoicing.vue"
export default component.exports